import React, { useState } from "react";
import { useTable, usePagination, useRowSelect } from "react-table";
import { Link } from "react-router-dom";
import Cards from "../Cards";
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import soporte_icono from "../../../../assets/vw/svg/soporte.svg";
import SEARCH from "../../../../assets/vw/svg/search.svg";
import protegida_icono from "../../../../assets/vw/svg/candado-cerrado.svg";
import no_protegida_icono from "../../../../assets/vw/svg/candado-abierto.svg";
import null_icono from "../../../../assets/vw/svg/null.svg";
import double_before from "../../../../assets/vw/svg/double-before.svg";
import before from "../../../../assets/vw/svg/before.svg";
import after from "../../../../assets/vw/svg/after.svg";
import double_after from "../../../../assets/vw/svg/double-after.svg";
import DropDown from "../../../../components/Dropdown";
import menu_opc from "../../../../assets/vw/svg/menu-opciones.svg";
import editar_icon from "../../../../assets/vw/svg/editar_blanco.svg";
import archivar_blanco from "../../../../assets/vw/svg/archivar_blanco.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import Loading from "../../../../components/Loading";
import success_icono from "../../../../assets/vw/svg/check-exito.svg";
import error_icono from "../../../../assets/vw/svg/check-error.svg";
import upload_icono from "../../../../assets/vw/svg/upload.svg";
import DropdownSearch from "../../../../components/DropdownSearch";
import editar_icono from "../../../../assets/vw/svg/editar.svg";
import InputText from "../../../../components/InputText";
import StaticTextField from "../../../../components/StaticTextField";
import TextArea from "../../../../components/TextArea";
import delete_icon from "../../../../assets/vw/svg/eliminar.svg";
import icon_app from  "../../../../assets/vw/svg/app_icono.svg";



const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <>
        <input
          type="checkbox"
          className="checkbox-round"
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

function Table({
  columns,
  data,
  servicio,
  marca,
  tiposAutenticacion,
  handleChange,
}) {
  const [cargando, setCargando] = useState(false);
  const [agregar, setAgregar] = useState(false);
  const [activo, setActivo] = useState(true);
  const [protegida, setProtegida] = useState();
  const [worldApp, setWorldApp] = useState();
  const [destacada, setDestacada] = useState();
  const [path, setPath] = useState("");
  const [pathSoporte, setPathSoporte] = useState("");
  const [idApp, setIdApp] = useState("");
  const [url, setUrl] = useState("");
  const [nombreCodeBuild, setNombreCodeBuild] = useState("");
  const [nombre, setNombre] = useState("");
  const [iconFile, setIconFile] = useState("");
  const [iconoNombreArchivo, setIconoNombreArchivo] = useState("");
  const [fechaCreacion, setFechaCreacion] = useState("");
  const [emailNoReply, setEmailNoReply] = useState("");
  const [fcm, setFcm] = useState("");
  const [pinpoint, setPinpoint] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const estadoCat = ["Activo", "Inactivo"];
  const algoritmoCat = ["RS256", "HS256", "HS384", "HS512"];
  const [showGrid, setShowGrid] = useState(false);
  const [selectGrid, setSelectGrid] = useState([]);
  const [selectedApp, setSelectedApp] = useState();
  const [mensajePrueba, setMensajePrueba] = useState("");
  const [pruebaExito, setPruebaExito] = useState(false);

  const [configWhatsApp, setconfigWhatsApp] = useState({
    token: "",
    nameSpace: "",
    userName: "",
    idApp: "",
    campaignAlias: "",
    activo: 1,
    idAppWhatsApp: 0,
  });

  const [oauthOptions, setOauthOptions] = useState({
    iss: "",
    sub: "",
    tiempo: "",
    pem: "",
    algoritmo: "",
    idTipoAutenticacion: 0,
    idApp: idApp,
    activo: 1,
    urlToken: "",
    aud: "",
  });

  const [autenticaciones, setAutenticaciones] = useState([]);
  const [oauths, setOAuths] = useState([]);

  const [clientID, setClientID] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [idTipoAutenticacion, setIdTipoAutenticacion] = useState(0);
  const [tipoActivo, setTipoActivo] = useState(true);
  const [vigenciaTokenDTO, setVigenciaTokenDTO] = useState(null);

  const [limit, setLimit] = useState(10);
  const limitMostrar = ["Mostrar 15", "Mostrar 30", "Mostrar 50", "Todo"];
  const [rowArchivar, setRowArchivar] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensajeArchivar, setMensajeArchivar] = useState(
    "¿Seguro que quieres archivar esta aplicación?"
  );
  const [successArchivar, setSuccessArchivar] = useState(false);
  const [errorArchivar, setErrorArchivar] = useState(false);
  const [mostrarModalApp, setMostrarModalApp] = useState(false);
  const [option, setOption] = useState("general");

  React.useEffect(() => {
    setOauthOptions((prevState) => ({
      ...prevState,
      idApp: idApp,
    }));
  }, [idApp]);

 

  const optionLimit = (textoLimit) => {
    switch (textoLimit) {
      case "Mostrar 15":
        return 15;
      case "Mostrar 30":
        return 30;
      case "Mostrar 50":
        return 50;
      case "Todo":
        return data.length;
      default:
        return data.length;
    }
  };

  function searchText(e) {
    setSearchInput(e.target.value);
    handleChange(e);
  }

  function nuevo() {
    setMostrarModalApp(true);
    setIdApp("");
    setPath("");
    setPathSoporte("");
    setUrl("");
    setClientSecret("");
    setClientID("");
    setIconoNombreArchivo("");
    setNombre("");
    setFechaCreacion("");
    setActivo(true);
    setAgregar(true);
    setProtegida(false);
    setWorldApp(false);
    setDestacada(false);
    setEmailNoReply("");
    setFcm("");
    setPinpoint("");
  }

  function cancelar() {
    setOption("general");
    setMostrarModalApp(false);
    limpiarOAuth();
    setOAuths([]);
    setAutenticaciones([]);
    setconfigWhatsApp({
      token: "",
      nameSpace: "",
      userName: "",
      campaignAlias: "",
      idApp: "",
      activo: 1,
      idAppWhatsApp: 0,
    });
    limpiarAutenticacion();
  }

  async function envia() {
    let helperAutenticaciones = autenticaciones.map((e) => {
      if (e.clientId === undefined || e.clientId !== e.client_id)
        e.clientId = e.client_id;
      if (e.clientSecret === undefined || e.clientSecret !== e.client_secret)
        e.clientSecret = e.client_secret;
      if (e.activo === true || e.activo === "true") e.activo = 1;
      if (e.activo === false || e.activo === "false") e.activo = 0;
      if (e.vigenciaTokenDTO === null || e.vigenciaTokenDTO === undefined || e.vigenciaTokenDTO.trim() === "") {
        e.vigenciaTokenDTO = null;
      } else {
        e.vigenciaTokenDTO = e.vigenciaTokenDTO.replace(/\s+/g, '');
      }
      return e;
    });
    setAutenticaciones(helperAutenticaciones);
    setMostrarModalApp(false);
    setCargando(true);
    if (iconFile) {
      await getBase64(iconFile)
        .then((icono) => {
          enviaInformacion(icono);
        })
        .catch((errorFile) => {
          setCargando(false);
        });
    } else {
      enviaInformacion("");
    }
  }

  async function enviaInformacion(icono) {
    let responseMessage = "";
    try {
        let response = await fetch(
          process.env.REACT_APP_URL_DTO_BACK + "aplicacion",
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + servicio.getToken(),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              idApp,
              nombre,
              activo,
              url,
              protegida,
              destacada,
              worldApp,
              path,
              pathSoporte,
              icono,
              iconoNombreArchivo,
              emailNoReply,
              fcm,
              pinpoint,
              autenticaciones, 
              nombreCodeBuild
            }),
          }
        );
      responseMessage = await response.json();
      console.log(responseMessage);

      if (!response.ok) {
        throw new Error("Ocurrió un error al guardar la aplicación. " + responseMessage.mensaje);
      }

      if (oauths.length > 0 && idApp !== "") {
        let responseAuth = await fetch(process.env.REACT_APP_URL_DTO_BACK + "autenticacionoauth", {
            method: "POST",
            headers: {
              Authorization: "Bearer " + servicio.getToken(),
              "Content-Type": "application/json",
            },
            body: JSON.stringify(oauths),
          });

        if (!responseAuth.ok) {
          throw new Error("Ocurrió un errror al guardar autenticación OAuth.");
        }
      }
      if (
        configWhatsApp.token !== "" &&
        configWhatsApp.userName !== "" &&
        configWhatsApp.nameSpace !== "" &&
        configWhatsApp.campaignAlias !== ""
      ) {
        let responseWA = await fetch(process.env.REACT_APP_URL_DTO_BACK + "whatsapp", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + servicio.getToken(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(configWhatsApp),
        });

        if (!responseWA.ok) {
          throw new Error("Ocurrió un errror al guardar las configuraciones de WhatsApp.");
        }
      }

      setCargando(false);
      setMensajeArchivar("Los cambios fueron guardados.");
      setSuccessArchivar(true);
      setMostrarModal(true);
    } catch (error) {
      setCargando(false);
      setMensajeArchivar(error.message);
      setErrorArchivar(true);
      setMostrarModal(true);
    }
  }

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  function handleInputsOAuth(input) {
    const { name, value } = input;
    setOauthOptions((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }



  function handleSubmit(event) {
    event.preventDefault();
    let index = oauths.findIndex(
      (oauth) => oauth.idTipoAutenticacion === oauthOptions.idTipoAutenticacion
    );
    if (index >= 0) {
      let oauthsTemp = oauths;
      oauthsTemp[index] = oauthOptions;
      setOAuths([...oauthsTemp]);
    } else {
      setOAuths((prevState) => [...prevState, oauthOptions]);
    }
    limpiarOAuth();
  }

  function handleCheckBoxActivo({ target }) {
    if (activo || activo === 1) setActivo(false);
    else setActivo(true);
  }

  function handleCheckBoxProtegida({ target }) {
    if (protegida || protegida === 1) setProtegida(false);
    else setProtegida(true);
  }

  function handleCheckBoxDestacada({ target }) {
    if (destacada || destacada === 1) setDestacada(false);
    else setDestacada(true);
  }

  function handleCheckBoxWorldApp({ target }) {
    if (worldApp || worldApp === 1) setWorldApp(false);
    else setWorldApp(true);
  }

  function handleChangeFile(event) {
    setIconFile(event.target.files[0]);
    setIconoNombreArchivo(event.target.files[0].name);
  }

  function editar(e) {
    if (e.row.original.idApp !== "" && e.row.cells.length > 0) {
      setCargando(true);
      setAgregar(false);
      setMensajePrueba("");
      setPruebaExito(false);
      fetch(
        process.env.REACT_APP_URL_DTO_BACK +
          "aplicacion?aplicacion=" +
          e.row.original.idApp,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      )
        .then(async (res) => {
          let responseBody = await res.json();
          if (!res.ok) {
            throw new Error(responseBody.mensaje);
          }
          setMostrarModalApp(true);
          setIdApp(responseBody.mensaje[0].idApp);
          setPath(
            responseBody.mensaje[0].path ? responseBody.mensaje[0].path : ""
          );
          setPathSoporte(
            responseBody.mensaje[0].pathSoporte
              ? responseBody.mensaje[0].pathSoporte
              : ""
          );
          setUrl(
            responseBody.mensaje[0].url ? responseBody.mensaje[0].url : ""
          );
          setNombreCodeBuild(responseBody.mensaje[0].nombreCodeBuild)
          setAutenticaciones(responseBody.mensaje[0].autenticaciones);
          setIconoNombreArchivo(responseBody.mensaje[0].icono);
          setNombre(responseBody.mensaje[0].nombre);
          setActivo(responseBody.mensaje[0].activo === 1 ? true : false);
          setDestacada(responseBody.mensaje[0].destacada === 1 ? true : false);
          setWorldApp(responseBody.mensaje[0].worldApp === 1 ? true : false);
          setProtegida(responseBody.mensaje[0].protegida === 1 ? true : false);
          setFechaCreacion(responseBody.mensaje[0].fechaRegistro);
          setEmailNoReply(responseBody.mensaje[0].correoNoReply);
          setFcm(responseBody.mensaje[0].FCM);
          setPinpoint(responseBody.mensaje[0].pinpoint);
          setconfigWhatsApp({
            ...configWhatsApp,
            idApp: responseBody.mensaje[0].idApp,
          });
          try {
            let result = await fetch(
              process.env.REACT_APP_URL_DTO_BACK +
                "autenticacionoauth?idApp=" +
                e.row.original.idApp,
              {
                method: "GET",
                headers: {
                  Authorization: "Bearer " + servicio.getToken(),
                  "Content-Type": "application/json",
                },
              }
            );
            let responseBody = await result.json();
            if (!result.ok) {
              throw new Error(responseBody.mensaje);
            }
            if (Array.isArray(responseBody.mensaje))
              setOAuths([...responseBody.mensaje]);
          } catch (error) {
            alert("Las autenticaciones OAuth no se cargaron.");
            setCargando(false);
          }

          try {
            let result = await fetch(process.env.REACT_APP_URL_DTO_BACK + "whatsapp?idApp=" + e.row.original.idApp + "&source=jarvis",
              {
                method: "GET",
                headers: {
                  Authorization: "Bearer " + servicio.getToken(),
                  "Content-Type": "application/json",
                },
              }
            );

            let responseBody = await result.json();
            if (!result.ok) {
              throw new Error(responseBody.mensaje);
            }
            if (responseBody.mensaje.length > 0)
              setconfigWhatsApp({ ...responseBody.mensaje[0] });
          } catch (error) {
            alert("Las configuracion de whatsapp no se cargaron.");
            setCargando(false);
          }

          setCargando(false);
        })
        .catch((errorP) => {
          setCargando(false);
        });
    }
  }

  function changeOption(option) {
    setOption(option);
    setMensajePrueba("");
    setPruebaExito(false);
  }

  function handleArchivar(e) {
    selectedFlatRows.length < 1 && selectGrid.length < 1
      ? setRowArchivar(e.row.original)
      : setRowArchivar("");
    setMostrarModal(true);
  }

  function clearModalArchivar() {
    if (successArchivar || errorArchivar) {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } else {
      setRowArchivar("");
      setMostrarModal(false);
      setMensajeArchivar("¿Seguro que quieres archivar esta aplicación?");
      setSuccessArchivar(false);
      setErrorArchivar(false);
    }
  }

  function activaDesactiva() {
    setCargando(true);
    setMostrarModal(false);
    let arrayIdApp = [];
    if (rowArchivar !== "") {
      arrayIdApp.push(rowArchivar);
    } else if (selectedFlatRows.length > 0) {
      arrayIdApp = selectedFlatRows.map((row) => row.original);
    } else if (selectGrid.length > 0) {
      arrayIdApp = selectGrid;
    }

    for (let rowApp of arrayIdApp) {
      fetch(process.env.REACT_APP_URL_DTO_BACK + "aplicacion", {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idApp: rowApp.idApp,
        }),
      })
        .then(async (res) => {
          let responseBody = await res.json();
          if (!res.ok) {
            throw new Error(responseBody.mensaje);
          }
          console.log(responseBody);
          setRowArchivar("");
          setCargando(false);
          setMensajeArchivar("Los cambios fueron guardados.");
          setSuccessArchivar(true);
          setMostrarModal(true);
        })
        .catch((errorP) => {
          setRowArchivar("");
          setCargando(false);
          setMensajeArchivar("Hubo un error al guardar los cambios.");
          setErrorArchivar(true);
          setMostrarModal(true);
        });
    }
  }

  function limpiarAutenticacion() {
    setIdTipoAutenticacion(0);
    setClientID("");
    setTipoActivo(true);
    setClientSecret("");
    setVigenciaTokenDTO(null);
  }

  function limpiarOAuth() {
    setOauthOptions({
      iss: "",
      sub: "",
      tiempo: "",
      pem: "",
      algoritmo: "",
      idTipoAutenticacion: 0,
      idApp: idApp,
      activo: 1,
      urlToken: "",
      aud: "",
    });

    setMensajePrueba("");
    setPruebaExito(false);
  }

  function agregarAutenticacion() {
    let autenticacionesTmp = autenticaciones;
    let tmp = autenticacionesTmp.filter(
      (x) => x.idTipoAutenticacion === idTipoAutenticacion
    );

    if (tmp.length > 0) {
      let index = autenticacionesTmp.findIndex(
        (x) => x.idTipoAutenticacion === idTipoAutenticacion
      );

      tmp = autenticacionesTmp.splice(index, 1);

      tmp[0].idTipoAutenticacion = idTipoAutenticacion;
      tmp[0].client_id = clientID;
      tmp[0].client_secret = clientSecret;
      tmp[0].clientId = clientID;
      tmp[0].clientSecret = clientSecret;
      tmp[0].activo = tipoActivo === true ? 1 : 0;
      tmp[0].vigenciaTokenDTO = vigenciaTokenDTO;

      autenticacionesTmp.push(tmp[0]);
    } else {
      autenticacionesTmp.push({
        idTipoAutenticacion:
          idTipoAutenticacion === undefined ? 0 : idTipoAutenticacion,
        clientId: clientID,
        client_id: clientID,
        clientSecret: clientSecret,
        client_secret: clientSecret,
        activo: tipoActivo === true ? 1 : 0,
        vigenciaTokenDTO: vigenciaTokenDTO,
      });
    }
    setAutenticaciones(autenticacionesTmp);
    limpiarAutenticacion();
  }

  function editaTipoAutenticacion(id) {
    let tmp = autenticaciones.filter((x) => x.idTipoAutenticacion === id);

    if (tmp.length > 0) {
      limpiarAutenticacion();
      setIdTipoAutenticacion(tmp[0].idTipoAutenticacion);
      setTipoActivo(tmp[0].activo === 1 ? true : false);
      setClientID(
        tmp[0].clientId === undefined
          ? tmp[0].client_id === null || tmp[0].client_id === undefined
            ? " "
            : tmp[0].client_id
          : tmp[0].clientId
      );
      setClientSecret(
        tmp[0].clientSecret === undefined
          ? tmp[0].client_secret === null || tmp[0].client_secret === undefined
            ? " "
            : tmp[0].client_secret
          : tmp[0].clientSecret
      );
      setVigenciaTokenDTO(tmp[0].vigenciaTokenDTO === undefined
        ? tmp[0].vigenciaTokenDTO === null || tmp[0].vigenciaTokenDTO === undefined
          ? ""
          : tmp[0].vigenciaTokenDTO
        : tmp[0].vigenciaTokenDTO);
    } else {
      alert("Elija una Autenticacion.");
    }
  }

  function eliminaTipoAutenticacion(id) {
    let autenticacionesTmp = autenticaciones;

    let tmp = autenticacionesTmp.filter((x) => x.idTipoAutenticacion !== id);

      setAutenticaciones(tmp)
    
  }

  function editarOAuth(oauth) {
    setOauthOptions(oauth);
  }

  function eliminaOAuth(OAuth) {
    
    let OathsTmp = oauths;

    let tmp = OathsTmp.filter((x) => x.idAutenticacion !== OAuth.idAutenticacion);
    setOAuths(tmp)
  }

  //modal archivar
  const buildPopUp = () => {
    return (
      <div
        className={`modal modal_vw modal_popup_vw fade ${mostrarModal ? "show" : ""}`}
        id="desarchivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_popup_content">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearModalArchivar}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-3 p-sm-5 p-lg-5`}>
              {buildContent()}
              {successArchivar || errorArchivar ? "" : buildButtons()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const buildContent = () => {
    return (
      <>
        {successArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={success_icono}
                className="icono-mensaje"
                alt="exito"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : errorArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={error_icono}
                className="icono-mensaje"
                alt="error"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <label className="popup_title d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        )}
      </>
    );
  };

  const buildButtons = () => {
    return (
      <div className="d-flex justify-content-center gap-3 mt-3 mt-sm-4 mt-lg-5 mb-3 mb-lg-5">
        <button
          type="button"
          className="button_vw button_vw--secondary"
          data-bs-dismiss="modal"
          onClick={clearModalArchivar}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="button_vw button_vw--primary"
          data-bs-dismiss="modal"
          onClick={activaDesactiva}
        >
          Archivar
        </button>
      </div>
    );
  };

  const buildPopUpApp = () => {
    return (
      <div
        className={`modal modal_vw fade ${mostrarModalApp ? "show" : ""}`}
        id="modalApp"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={mostrarModalApp ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_lg_vw">
          <div className="modal-content modal_content-vw p-0 p-lg-2">
            <div className="modal-header modal_header-vw ">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={cancelar}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body mx-3 mx-sm-4 mx-lg-5 p-0 mb-2 mb-sm-4 mb-lg-0`}>
              <div className="modal-title-container d-flex justify-content-start titulo mb-4">
                <span className={"modal-title-principal-text"}>{agregar ? "Nueva aplicación" : "Editar aplicación"}</span>
                {
                  !agregar && (
                    <button
                      type="button"
                      className={"button_vw button_vw--archivo modal-btn-archivar-top"}
                      onClick={() => {
                        if (selectedApp) {
                          handleArchivar(selectedApp);
                        }
                      }}
                    >
                      <div className={"archivar-icon"}></div>
                      <span className={"ml-2"}>Archivar</span>
                    </button>
                  )
                }
              </div>
              <div className="row titulo-opciones m-0">
                <div className="col-3 p-0">
                  <label
                      className={`label_option ${
                          option === "general" && "border-label"
                      }`}
                      onClick={() => changeOption("general")}
                  >
                    <div className={"document_icon " + (option === "general" && "icon--blue")} />
                    <span className={"tab_modal_title"}>General</span>
                  </label>
                </div>
                <div className="col-3 p-0">
                  <label
                      className={`label_option ${
                          option === "proveedor" && "border-label"
                      }`}
                      onClick={() => changeOption("proveedor")}
                  >
                    <div className={"user_icon "  + (option === "proveedor" && "icon--blue")}/>
                    <span className={"tab_modal_title"}>Proveedor de identidad{" "}</span>
                  </label>
                </div>
                <div className="col-3 p-0">
                  <label
                      className={`label_option ${
                          option === "auth" && "border-label"
                      }`}
                      onClick={() => changeOption("auth")}
                  >
                    <div className={"key_icon " + (option === "auth" && "icon--blue")}/>
                    <span className={"tab_modal_title"}>Autenticación OAuth{" "}</span>
                  </label>
                </div>
                <div className="col-3 p-0">
                  <label
                      className={`label_option ${
                          option === "whatsapp" && "border-label"
                      }`}
                      onClick={() => changeOption("whatsapp")}
                  >
                    <div className={"whatsapp_icon " + (option === "whatsapp" && "icon--blue")}/>
                    <span className={"tab_modal_title"}>Configuración de WhatsApp{" "}</span>
                  </label>
                </div>
                <div className="col-12 border_vw"></div>
                {option === "general" && buildGeneral()}
                {option === "proveedor" && builProveedor()}
                {option === "auth" && builAutenticacion()}
                {option === "whatsapp" && buildWhatsapp()}
                {buildButtonsApp()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const buildGeneral = () => {
    return (
      <>
        <div className="row p-0 mx-0 mt-4">
          <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2 mt-sm-0">
            <InputText
              inputLabel={"Nombre"}
              inputField={nombre}
              changingInput={(event) => {
                setNombre(event.target.value);
              }}
              id={"nombre"}
            />
          </div>
          <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 pt-0 mt-2 mt-sm-0">
            <InputText
              inputLabel={"Correo no-reply"}
              inputField={emailNoReply ? emailNoReply : ""}
              id={"emailNoReply"}
              type="email"
              changingInput={(event) => {
                setEmailNoReply(event.target.value);
              }}
            />
          </div>
        </div>
        <div className="row p-0 mx-0 mt-0 mt-sm-2">
          <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2 mt-sm-0">
            <InputText
              inputLabel={"Path"}
              inputField={path}
              id={"path"}
              changingInput={(event) => {
                setPath(event.target.value);
              }}
            />
          </div>
          <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 pt-0 mt-2 mt-sm-0">
            <InputText
              inputLabel={"FCM"}
              inputField={fcm ? fcm : ""}
              id={"fcm"}
              changingInput={(event) => {
                setFcm(event.target.value);
              }}
            />
          </div>
        </div>
        <div className="row p-0 mx-0 mt-0 mt-sm-2">
          <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2 mt-sm-0">
            <InputText
              inputLabel={"Path soporte"}
              inputField={pathSoporte}
              changingInput={(event) => {
                setPathSoporte(event.target.value);
              }}
              id={"pathSoporte"}
            />
          </div>
          <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 pt-0 mt-2 mt-sm-0">
            <InputText
              inputLabel={"Pinpoint"}
              inputField={pinpoint ? pinpoint : ""}
              changingInput={(event) => {
                setPinpoint(event.target.value);
              }}
              id={"pinpoint"}
            />
          </div>
        </div>
        <div className="row p-0 mx-0 mt-0 mt-sm-2">
          <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2 mt-sm-0">
            <InputText
              inputLabel={"URL"}
              inputField={url}
              changingInput={(event) => {
                setUrl(event.target.value);
              }}
              id={"url"}
            />
          </div>

          <div className="input-fecha-modal col-6 col-sm-3 ps-0 pl-0 pl-sm-2 pr-2 mt-2 mt-sm-0">
            <StaticTextField 
              value={fechaCreacion}
              inputLabel={"Fecha de creación"}
              type="date"
            />
          </div>
          <div className="col-6 col-sm-3 px-0 m-0 p-0 pl-2 mt-2 mt-sm-0">
            <input
              type="file"
              name="fileInput"
              id="fileInput"
              className="input_vw inputfile"
              accept="image/*"
              onChange={handleChangeFile}
            />
            <label htmlFor="fileInput" className="input_vw d-flex p-2">
              <span className="flex-grow-1">
                {iconoNombreArchivo === ""
                  ? "Cargar ícono"
                  : iconoNombreArchivo}
              </span>
              <span>
                <img src={upload_icono} alt="upload" />
              </span>
            </label>
          </div>

          <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2">
            <InputText
              inputLabel={"Nombre de CodeBuild"}
              inputField={nombreCodeBuild}
              changingInput={(event) => {
                setNombreCodeBuild(event.target.value);
              }}
              id={"nombreCodeBuild"}
            />
          </div>
          <div className="app-build-general-checkboxes d-flex align-items-center flex-row flex-wrap">
            <div className="pe-3 col-6 col-sm-3 d-flex align-items-center">
              <input
                type="checkbox"
                className="checkbox-round"
                id="activo"
                checked={activo ? activo : false}
                disabled={agregar}
                onChange={handleCheckBoxActivo}
              />
              <label className="ps-1 label-font-responsive">Activo</label>
            </div>
            <div className="p-3 col-6 col-sm-3 d-flex align-items-center">
              <input
                type="checkbox"
                className="checkbox-round"
                id="protegida"
                checked={protegida ? protegida : false}
                onChange={handleCheckBoxProtegida}
              />
              <label className="ps-1 label-font-responsive">Protegida</label>
            </div>
          </div>
        </div>
      </>
    );
  };

  const builProveedor = () => {
    return (
      <>
        {idApp !== "" ? (
          <>
            <div className="row m-0 p-0 pt-3">
              {autenticaciones.map((autenticacion) => {
                return (
                  <div
                    key={
                      "autenticaciones--" + autenticacion.idTipoAutenticacion
                    }
                    className="d-flex p-0"
                  >
                    <div className="flex-grow-1">
                      {autenticacion.activo === 1 ? (
                        <img
                          src={activo_icono}
                          className="icono_marcador me-2"
                          alt="activo"
                        ></img>
                      ) : (
                        <img
                          src={inactivo_icono}
                          className="icono_marcador me-2"
                          alt="activo"
                        ></img>
                      )}
                      <span className="label_text pt-2">
                        {
                          tiposAutenticacion.filter(
                            (x) =>
                              x.idTipoAutenticacion ===
                              autenticacion.idTipoAutenticacion
                          )[0]?.nombre
                        }
                      </span>
                    </div>

                    <div>
                      <button
                        className="button_icon-vw"
                        onClick={(e) => {
                          editaTipoAutenticacion(
                            autenticacion.idTipoAutenticacion
                          );
                        }}
                      >
                        <img src={editar_icono} alt="editar"></img>
                      </button>
                    </div>
                    <div>
                      <button
                        className="button_icon-vw"
                        onClick={(e) => {
                          eliminaTipoAutenticacion(
                            autenticacion.idTipoAutenticacion
                          );
                        }}
                      >
                        <img src={delete_icon} alt="eliminar"></img>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="row p-0 mx-0 mt-4">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                <DropdownSearch
                  menu={tiposAutenticacion.reduce((acc, actual) => {
                    if (actual.protocolo === 1) {
                      acc.push(actual)
                    }
                    return acc;
                  }, [])}
                  title={"Autenticación"}
                  defaultValue={idTipoAutenticacion}
                  handleOptionSelected={(e) => {
                    setIdTipoAutenticacion(parseInt(e.props.value));
                  }}
                  fieldID={'idTipoAutenticacion'}
                  fieldToShow={'nombre'}
                />
              </div>
              <div className="col-12 col-sm-6 pe-0 pl-0 pl-sm-2 pt-3 pt-sm-0 mt-2 mt-sm-0">
                <InputText
                  inputLabel={"Client Secret"}
                  inputField={clientSecret}
                  changingInput={(event) => {
                    setClientSecret(event.target.value);
                  }}
                  id={"clientSecret"}
                />
              </div>
            </div>
            <div className="row  p-0 mx-0 mt-2">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                <InputText
                  inputLabel={"Client ID"}
                  inputField={clientID}
                  id={"clientID"}
                  changingInput={(event) => {
                    setClientID(event.target.value);
                  }}
                />
              </div>
              <div className="col-12 col-sm-6 pe-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                <DropdownSearch
                  menu={estadoCat.map((ele, index) => {
                    return {
                      nombre: ele
                    }
                  })}
                  title={"Estado"}
                  defaultValue={tipoActivo ? "Activo" : "Inactivo"}
                  handleOptionSelected={(e) => {
                    let status = e.props.value === "Activo" ? true : false;
                    setTipoActivo(status);
                  }}
                  fieldID={'nombre'}
                  fieldToShow={'nombre'}
                />
              </div>
            </div>
            <div className="row  p-0 mx-0 mt-4 mt-md-2">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
              <InputText
                  inputLabel={"Vigencia token DTO (ej: 30s, 5m,1h, 7d, 2w, 1y)"}
                  inputField={vigenciaTokenDTO}
                  id={"vigenciaTokenDTO"}
                  validationFunction={(e) => {
                    const value = e.target.value.trim();
                    if (value === "") return true;
                    if (/[A-Z]/.test(value)) return false;
                    if (!/^\d/.test(value)) return false;
                    if (!/^(\d+)?([smhdwy])?$/.test(value)) return false;

                    const match = value.match(/^(\d+)([smhdwy])$/);
                    if (!match) return true;

                    const num = parseInt(match[1], 10);
                    const unit = match[2];

                    const limits = {
                      s: 31536000,
                      m: 525600,
                      h: 8760,
                      d: 365,
                      w: 52,
                      y: 1
                    };

                    return num <= limits[unit];
                  }}
                  changingInput={(event) => {
                    setVigenciaTokenDTO(event.target.value);
                  }}
                />
              </div>
            </div>
            <div className="row mt-4 mt-sm-0 mt-lg-4 p-0 mx-0">
              <div className="app-proveedor-actions d-flex justify-content-center gap-3 mt-0 mt-sm-4 mt-lg-5 mb-5">
                <button
                  type="button"
                  className="button_vw button_vw--secondary"
                  data-bs-dismiss="modal"
                  onClick={()=>{limpiarAutenticacion()}}
                >
                  Limpiar
                </button>
                <button
                  type="button"
                  className="button_vw button_vw--extra"
                  onClick={agregarAutenticacion}
                >
                  Agregar
                </button>
              </div>
            </div>
          </>
        ) : idApp === "" ? (
          <div className="container">
            <div className="d-flex justify-content-center my-5 py-5">
              <label>
                No hay una app seleccionada para crear la configuración de
                proveedor.
              </label>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const onChangeDias = (event) => {
    let value = event.target.value;
    const pattern = new RegExp("^[0-9]*$");
    let isValidKey = pattern.test(value);
    if (isValidKey) {
      handleInputsOAuth({
        name: "tiempo",
        value: event.target.value,
      });
    }
  };

  async function probarAutenticacion (){
    setPruebaExito(false)
    setMensajePrueba("Prueba en proceso");
    try {
      let response = await fetch(
        process.env.REACT_APP_URL_DTO_BACK + "aplicacion/generartoken",
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + servicio.getToken(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            idApp: idApp,
            idTipoAutenticacion: oauthOptions.idTipoAutenticacion
          })
        }
      )

      let responseBody = await response.json();

      if (responseBody.mensaje === "ok") {
        setMensajePrueba("La prueba de autenticación fue exitosa");
        setPruebaExito(true);
      } else {
        throw new Error("Error al probar la autenticación.");
      }
    } catch (error) {
      setMensajePrueba("Ha ocurrido un error durante la prueba de autenticación");
      setPruebaExito(false);
    }
  }

  const builAutenticacion = () => {
    return (
      <>
        {idApp !== "" ? (
          <form onSubmit={handleSubmit} className={"mb-5 mb-sm-0"}>
            <div className="row m-0 p-0 pt-3">
              {oauths.map((oauth) => {
                return (
                  <div
                    key={"autenticaciones--" + oauth.idTipoAutenticacion}
                    className="d-flex p-0"
                  >
                    <div className="flex-grow-1">
                      {oauth.activo ? (
                        <img
                          src={activo_icono}
                          className="icono_marcador me-2"
                          alt="activo"
                        ></img>
                      ) : (
                        <img
                          src={inactivo_icono}
                          className="icono_marcador me-2"
                          alt="activo"
                        ></img>
                      )}
                      <span className="label_text pt-2">
                        {
                          tiposAutenticacion.filter(
                            (x) =>
                              x.idTipoAutenticacion ===
                              parseInt(oauth.idTipoAutenticacion)
                          )[0].nombre
                        }
                      </span>
                    </div>
                    <div>
                      <button
                        className="button_icon-vw"
                        type="button"
                        onClick={(e) => {
                          editarOAuth(oauth);
                        }}
                      >
                        <img src={editar_icono} alt="editar"></img>
                      </button>
                    </div>
                    <div>
                      <button
                        className="button_icon-vw"
                        type="button"
                        onClick={(e) => {
                          eliminaOAuth(oauth);
                        }}
                      >
                        <img src={delete_icon} alt="eliminar"></img>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="row  p-0 mx-0 mt-4">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                <DropdownSearch
                  menu={tiposAutenticacion.reduce((acc, actual) => {
                    if (actual.protocolo === 2) {
                      let temp = actual;

                      if (!(
                        oauths.findIndex((oauth) => parseInt(oauth.idTipoAutenticacion) === actual.idTipoAutenticacion) < 0
                      )) {
                        temp.disabled = true;
                      }
                      acc.push(temp);
                    }
                    return acc;
                  }, [])}
                  title={"Autenticación"}
                  defaultValue={oauthOptions.idTipoAutenticacion}
                  handleOptionSelected={(e) => {
                    handleInputsOAuth({
                      name: "idTipoAutenticacion",
                      value: e.props.value,
                    });
                  }}
                  fieldID={'idTipoAutenticacion'}
                  fieldToShow={'nombre'}
                />
              </div>
              <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 pt-3 pt-sm-0 mt-2 mt-sm-0">
                <InputText
                  inputLabel={"AUD"}
                  id={"AUD"}
                  inputField={oauthOptions.aud}
                  required={true}
                  changingInput={(event) => {
                    handleInputsOAuth({
                      name: "aud",
                      value: event.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="row mt-2 p-0 mx-0">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                <InputText
                  inputLabel={"ISS"}
                  id={"ISS"}
                  inputField={oauthOptions.iss}
                  required={true}
                  changingInput={(event) => {
                    handleInputsOAuth({
                      name: "iss",
                      value: event.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                <DropdownSearch
                  menu={algoritmoCat.map((ele, index) => {
                    return {
                      id: ele
                    }
                  })}
                  title={"Algoritmo"}
                  defaultValue={oauthOptions.algoritmo}
                  handleOptionSelected={(e) => {
                    handleInputsOAuth({ name: "algoritmo", value: e.props.value });
                  }}
                  fieldID={'id'}
                  fieldToShow={'id'}
                />
              </div>
            </div>
            <div className="row mt-2 p-0 mx-0">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-3 mt-sm-0">
                <InputText
                  inputLabel={"Sub"}
                  id={"Sub"}
                  inputField={oauthOptions.sub}
                  required={true}
                  changingInput={(event) => {
                    handleInputsOAuth({
                      name: "sub",
                      value: event.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                <DropdownSearch
                  menu={estadoCat.map((ele, index) => {
                    return {
                      nombre: ele
                    }
                  })}
                  title={"Estado"}
                  defaultValue={oauthOptions.activo ? "Activo" : "Inactivo"}
                  handleOptionSelected={(e) => {
                    let status = e.props.value === "Activo" ? true : false;
                    handleInputsOAuth({ name: "activo", value: status });
                  }}
                  fieldID={'nombre'}
                  fieldToShow={'nombre'}
                />
              </div>
            </div>
            <div className="row mt-2 p-0 mx-0">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                <div className="row mt-0 p-0 mx-0 mt-3 mt-sm-0">
                  <div className="col-12 px-0">
                    <InputText
                      inputLabel={"Tiempo (días)"}
                      id={"tiempo"}
                      inputField={oauthOptions.tiempo}
                      required={true}
                      changingInput={(e) => onChangeDias(e)}
                    />
                  </div>
                </div>
                <div className="row mt-2 p-0 mx-0">
                  <div className="col-12 px-0 ">
                  <InputText
                      inputLabel={"URL (Obtener token)"}
                      inputField={oauthOptions.urlToken}
                      required={true}
                      id={"token"}
                      changingInput={(e) => {
                        handleInputsOAuth({
                          name: "urlToken",
                          value: e.target.value,
                        });
                      }}
                    />
                    
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
              <TextArea
                  inputLabel={"PEM"}
                  id={"PEM"}
                  inputField={oauthOptions.pem}
                  changingInput={(e) => {
                    handleInputsOAuth({ name: "pem", value: e.target.value });
                  }}
                  required={true}
                  rows={4}
                />
                
              </div>
            </div>
            <div className="d-flex align-items-center p-0 mx-0 col-12 mb-2">
              <div className="col-6 p-0 m-0">
                <button
                  type="button"
                  className="button_vw button_vw--secondary col-5"
                  onClick={probarAutenticacion}
                  disabled={!(oauthOptions.idTipoAutenticacion === 2)}
                >
                  Probar autenticacion
                </button>
              </div>
              <div className="col-6 p-0 m-0">
                {
                  mensajePrueba !== "" ? (
                    mensajePrueba !== "Prueba en proceso" ? (
                      <div className="msg-error">
                        <label className={`icon${pruebaExito ? "--success":"--error"} p-0 m-0`}></label>
                        <span className={`mensaje${pruebaExito ? "--success":"--error"}`}>{mensajePrueba}</span>
                      </div>
                    ) : (
                      <div className="msg-error">
                        <span className="mensaje--loading">
                          <span>Prueba en proceso</span>
                          <span className="loading-dots">
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                          </span>
                        </span>
                      </div>
                    )
                  ) : (
                    <></>
                  )
                }
              </div>
            </div>
            <div className="row mt-0 p-0 mx-0">
              <div className="app-proveedor-actions d-flex justify-content-center gap-3 mt-2 mb-2 mb-sm-5 mb-lg-2">
                <button
                  type="button"
                  className="button_vw button_vw--secondary"
                  data-bs-dismiss="modal"
                  onClick={limpiarOAuth}
                >
                  Limpiar
                </button>
                <button type="submit" className="button_vw button_vw--extra">
                  Agregar
                </button>
              </div>
            </div>
          </form>
        ) : idApp === "" ? (
          <div className="container">
            <div className="d-flex justify-content-center my-5 py-5">
              <label>
                No hay una app seleccionada para crear la configuración de
                autenticación.
              </label>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const buildWhatsapp = () => {
    return (
      <>
        {idApp !== "" ? (
          <form className="p-0 mb-5 mb-sm-5">
            <div className="row mt-4 p-0 mx-0">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2 mt-sm-0">
              <InputText
                      inputLabel={"App"}
                      id={"App"}
                      inputField={ data.filter((ele) => {
                        return ele.idApp === idApp;
                      })[0].nombre}
                      required={true}
                      changingInput={(event) => {
                        setconfigWhatsApp({
                          ...configWhatsApp,
                          idApp: event.target.value,
                        });
                      }}
                    />

              </div>
              <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
              <InputText
                      inputLabel={"Name space"}
                      id={"nameSpace"}
                      inputField={configWhatsApp.nameSpace}
                      required={true}
                      changingInput={(event) => {
                        setconfigWhatsApp({
                          ...configWhatsApp,
                          nameSpace: event.target.value,
                        });
                      }}
                    />

              </div>
            </div>
            <div className="row  p-0 mx-0 mt-2">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
              <InputText
                      inputLabel={"Token"}
                      id={"token"}
                      inputField={configWhatsApp.token}
                      required={true}
                      changingInput={(event) => {
                        setconfigWhatsApp({
                          ...configWhatsApp,
                          token: event.target.value,
                        });
                      }}
                    />
               
              </div>
              <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
              <InputText
                      inputLabel={"Campaign Alias"}
                      id={"campaignAlias"}
                      inputField={configWhatsApp.campaignAlias}
                      required={true}
                      changingInput={(event) => {
                        setconfigWhatsApp({
                          ...configWhatsApp,
                          campaignAlias: event.target.value,
                        });
                      }}
                    />
                
              </div>
            </div>
            <div className="row  p-0 mx-0 mt-2">
              <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
              <InputText
                      inputLabel={"User name"}
                      id={"userName"}
                      inputField={configWhatsApp.userName}
                      required={true}
                      changingInput={(event) => {
                        setconfigWhatsApp({
                          ...configWhatsApp,
                          userName: event.target.value,
                        });
                      }}
                    />
                
                
              </div>
              <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0 mb-3 mb-sm-0">
                <DropdownSearch
                  menu={estadoCat.map((ele, index) => {
                    return {
                      nombre: ele
                    }
                  })}
                  title={"Estado"}
                  defaultValue={configWhatsApp.activo ? "Activo" : "Inactivo"}
                  handleOptionSelected={(e) => {
                    let status = e.props.value === "Activo" ? true : false;
                    setconfigWhatsApp((prevState) => ({
                      ...prevState,
                      activo: status,
                    }));
                  }}
                  fieldID={'nombre'}
                  fieldToShow={'nombre'}
                />
              </div>
            </div>
          </form>
        ) : idApp === "" ? (
          <div className="container">
            <div className="d-flex justify-content-center my-5 py-5">
              <label>
                No hay una app seleccionada para crear la configuración de
                WhatsApp.
              </label>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const buildButtonsApp = () => {
    return (
      <div className="modal-footer footer_modal_vw d-flex justify-content-center justify-content-lg-end gap-2 gap-sm-3 gap-lg-2 px-0">
        <button
          type="button"
          className="button_vw button_vw--secondary order-2 order-sm-1"
          data-bs-dismiss="modal"
          onClick={cancelar}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="button_vw button_vw--primary order-1 order-sm-2"
          data-bs-dismiss="modal"
          disabled={nombre === ""}
          onClick={envia}
        >
          Guardar
        </button>
      </div>
    );
  };

  const onChangeGrid = (value) => {
    setShowGrid(value);
    setSelectGrid([]);
    toggleAllRowsSelected(false);
  };

  const selects = (checkObj, tipo) => {
    if (tipo === "push") {
      setSelectGrid([...selectGrid, checkObj]);
    } else if (tipo === "pop") {
      let idConcesionaria = checkObj.idConcesionaria;
      setSelectGrid((l) =>
        l.filter((item) => item.idConcesionaria !== idConcesionaria)
      );
    }
  };

  const gridAplicaciones = (page) => {
    const selectCheck = (e, index) => {
      let y = document.getElementById(e.target.id);
      let concesionaria = page[index].original;
      if (y.checked) {
        selects(concesionaria, "push");
      } else {
        selects(concesionaria, "pop");
      }
    };

    return (
      <div className="grid__view row">
        {page.map((aplicacion, index) => {
          return (
            <div className="col-3 mb-3" key={index}>
              <div className="card_grid">
                <div className="d-flex">
                  <div className="container_id">
                    {aplicacion.original.idApp}
                  </div>
                  <div className="container_second">
                    {aplicacion.original.path.length > 17 ? `${aplicacion.original.path.substring(0, 14)}…`: aplicacion.original.path }
                  </div>
                  <div className="ms-auto">
                    <input
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"select-" + index}
                      value={aplicacion.original.idConcesionaria}
                      onChange={(e) => selectCheck(e, index)}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-start flex-column mx-3 mt-3 size-card">
                  <div
                    className="onclick"
                    onClick={() => {
                      setSelectedApp({row: aplicacion});
                      editar({row: aplicacion});
                    }}
                  >
                    <div className="w-100 d-flex flex-row align-items-center">
                    <div className=""><img src={icon_app} alt="icono" className="pe-2 "></img></div>
                    <div className="title_card">
                      {aplicacion.original.nombre.length > 16 ? `${aplicacion.original.nombre.substring(0, 13)}…` : aplicacion.original.nombre}
                    </div>
                    </div>
                    <div className="url_card ps-2 pt-2">url:</div>
                    <div className="url_description mb-auto ps-2">
                    {aplicacion.original.url.length > 40 ? `${aplicacion.original.url.substring(0, 37)}…` : aplicacion.original.url}
                    </div>
                  </div>
                  <div  >
                    <img src={activo_icono} alt="activo"></img>

                    {aplicacion.original.protegida === 1 ? (
                      <img src={protegida_icono} className="ps-2" alt="protegida"></img>
                    ) : (
                      <img src={no_protegida_icono} className="ps-2" alt="noprotegida"></img>
                    )}

                    {aplicacion.original.pathSoporte &&
                    aplicacion.original.pathSoporte !== "" ? (
                      <Link to={aplicacion.original.pathSoporte} data-track-click="link-soporte">
                        <img src={soporte_icono} className="ps-2" alt="soporte"></img>
                      </Link>
                    ) : (
                      ""
                    )}

                    <div className={` tooltip_vw`}>
                      <img src={menu_opc} alt="menu"></img>
                      <div className="tooltiptext p-2 ">
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => {
                            setSelectedApp({row: aplicacion})
                            editar({row: aplicacion});
                          }}
                        >
                          <div className="aling-icon">
                            {" "}
                            <img
                              src={editar_icon}
                              alt="editar"
                              className="px-1"
                            ></img>{" "}
                            Editar
                          </div>
                        </button>
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => handleArchivar({ row: aplicacion })}
                        >
                          <div className="aling-icon-archivar">
                            {" "}
                            <img
                              src={archivar_blanco}
                              alt="archivar"
                              className="px-2"
                            ></img>{" "}
                            Archivar
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    selectedFlatRows,
    setPageSize,
    state: {pageIndex},
    toggleAllRowsSelected,
  } = useTable(
      {
        columns,
        data,
        initialState: {pageSize: 15},
      },
      usePagination,
      useRowSelect,
      (hooks) => {
        hooks.visibleColumns.push((columns) => [
          {
            id: "selection",
            Header: ({getToggleAllPageRowsSelectedProps}) => (
                <div>
                  <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
                </div>
            ),
            Cell: ({row}) => (
                <div>
                  <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                </div>
            ),
          },
          ...columns,
        ]);
      }
  );

  const NavigationControl = () => {
    return (
        <div className="btn-group btn-group-controls" role="group" aria-label="First group">
          <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_before} alt="first"/>
          </button>
          {" "}
          <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={before} alt="before"/>
          </button>
          {" "}
          <div className="num_pagination py-3">
            {pageIndex + 1} de {pageOptions.length}
          </div>
          <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={after} alt="after"/>
          </button>
          {" "}
          <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_after} alt="last"/>
          </button>
          {" "}
        </div>
    );
  }

  return cargando ? (
      <Loading/>
  ) : (
      <>
        <div className="content main-content-container">
          <div className="main-content-actions row m-0 py-2">
            <div className="col-7 col-sm-6 col-lg-3 wrapper m-0 p-0 ">
              <input
                  className="input_vw"
                  name="searchInput"
                  value={searchInput || ""}
                  onChange={(e) => {
                    searchText(e);
                  }}
                  placeholder="Busca por ID, nombre, URL…"
              />
              <span className="pt-2 ps-1">
              <img src={SEARCH} alt="buscar" className="icono-menu me-3"/>
            </span>
            </div>

            <div className="d-flex col-1 col-sm-1 col-lg-3">
            <div className="d-flex justify-content-start"></div>
              <button
                  type="button"
                  onClick={nuevo}
                  className={"button_vw button_vw--primary button_new_item " + (!!(selectedFlatRows.length > 0 || selectGrid.length > 0) ? "is_not_enabled" : "enabled")}
                  disabled={!!(selectedFlatRows.length > 0 || selectGrid.length > 0)}
              >
                <div className={"add-icon"}></div>
                <span className={"ml-2"}>Nuevo</span>
              </button>

              {selectedFlatRows.length > 0 || selectGrid.length > 0 ? (
                  <button
                type="button"
                className={"button_vw button_vw--archivo button_store_item"}
                onClick={handleArchivar}
              >
                <div className={"archivar-icon"}></div>
                <span className={"ml-2"}>Archivar</span>
              </button>
            ) : (
                ""
            )}
          </div>

          <div className="col-3 col-sm-5 col-lg-6 p-0">
            <div className="d-flex justify-content-end align-items-center">
              <div className={`view_select_all ${showGrid ? 'icon_grid_active' : ''} ms-auto align-self-center`}>
                <input
                    type="checkbox"
                    className="checkbox-round mx-1"
                    id={"1"}
                    value={0}
                    onChange={() => {}}
                />
              </div>
              <div className="view__options">
                <button
                    className="button_icon-vw kit_icon"
                    type="button"
                    onClick={() => onChangeGrid(true)}
                >
                  <span
                      className={`${showGrid ? "icon-grid-active" : "icon-grid"}`}
                  >
                    {" "}
                  </span>
                </button>
                <button
                  className="button_icon-vw kit_icon"
                  type="button"
                  onClick={() => onChangeGrid(false)}
                >
                  <span
                    className={`${
                      !showGrid ? "icon-table-active" : "icon-table"
                    }`}
                  >
                    {" "}
                  </span>
                </button>
              </div>
              <div className="">
                <DropDown
                  menu={limitMostrar}
                  title={limitMostrar[0]}
                  inputField={limit}
                  handleOptionSelected={(e) => {
                    const limitInt = optionLimit(e);
                    setLimit(limitInt);
                    setPageSize(Number(limitInt));
                  }}
                />
              </div>
              <NavigationControl />
            </div>
          </div>
        </div>
      </div>
      <Cards
          page={page}
          editar={(seleccionada) => {
            setSelectedApp(seleccionada);
            editar(seleccionada);
          }}
          handleArchivar={handleArchivar}
          selects={selects}
          NavigationControl={NavigationControl}
      />
      {showGrid ? (
        gridAplicaciones(page)
      ) : (
        <div 
          className="table-responsive"
          style={{
            overflowY: 'hidden'
          }}
        >
        <table
          {...getTableProps()}
          className={"table table-striped table-responsive tabla_contenido_vw"}
        >
          <thead className="thead-dark ">
            {headerGroups.map((headerGroup) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className="thead__titulo"
              >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="tbody-table">
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className="table-tr-check">
                  {row.cells.map((cell, cellId) => {
                   if (cell.column.id !== "selection" && (cell.value === undefined || cell.value === "") ) {
                    return (
                      <td key={cellId}><img src={null_icono} alt="sinsoporte"></img></td>
                    );
                  }
                    if (cell.column.id === "selection") {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    }
                    if (cell.column.Header === "Activo") {
                      if (cell.value === 1) {
                        return (
                          <td
                            className="contenido_boolean"
                            {...cell.getCellProps()}
                            onClick={() => {
                              setSelectedApp(cell);
                              editar(cell);
                            }}
                          >
                            <img src={activo_icono} alt="activo"></img>
                          </td>
                        );
                      } else
                        return (
                          <td
                            className="contenido_boolean"
                            {...cell.getCellProps()}
                            onClick={() => {
                              setSelectedApp(cell);
                              editar(cell);
                            }}
                          >
                            <img src={inactivo_icono} alt="inactivo"></img>
                          </td>
                        );
                    }
                    if (cell.column.Header === "Protegida") {
                      if (cell.value === 1) {
                        return (
                          <td
                            className="contenido_boolean"
                            {...cell.getCellProps()}
                            onClick={() => {
                              setSelectedApp(cell);
                              editar(cell);
                            }}
                          >
                            <img src={protegida_icono} alt="protegida"></img>
                          </td>
                        );
                      } else
                        return (
                          <td
                            className="contenido_boolean"
                            {...cell.getCellProps()}
                            onClick={() => {
                              setSelectedApp(cell);
                              editar(cell);
                            }}
                          >
                            <img
                              src={no_protegida_icono}
                              alt="noprotegida"
                            ></img>
                          </td>
                        );
                    }
                    if (cell.column.Header === "Soporte") {
                      if (cell.value && cell.value !== "") {
                        return (
                          <td
                            className="contenido_boolean "
                            {...cell.getCellProps()}
                          >
                            <div className={`d-flex justify-content-between`}>
                              <Link to={cell.value} data-track-click="link-soporte">
                                <img src={soporte_icono} alt="soporte"></img>
                              </Link>
                              <div className={` tooltip_vw`}>
                                <img src={menu_opc} alt="menu"></img>
                                <div className="tooltiptext p-2 ">
                                  <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => {
                                      setSelectedApp(cell);
                                      editar(cell);
                                    }}
                                  >
                                    <div className="aling-icon">
                                      {" "}
                                      <img
                                        src={editar_icon}
                                        alt="editar"
                                        className="px-1"
                                      ></img>{" "}
                                      Editar
                                    </div>
                                  </button>
                                  <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => handleArchivar(cell)}
                                  >
                                    <div className="aling-icon-archivar">
                                      {" "}
                                      <img
                                        src={archivar_blanco}
                                        alt="archivar"
                                        className="px-2"
                                      ></img>{" "}
                                      Archivar
                                    </div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        );
                      } else {
                        return (
                          <td
                            className="contenido_boolean"
                            {...cell.getCellProps()}
                          >
                            <div className={`d-flex justify-content-between`}>
                              <img src={null_icono} alt="sinsoporte"></img>
                              <div className={` tooltip_vw`}>
                                <img src={menu_opc} alt="menu"></img>
                                <div className="tooltiptext p-2 ">
                                  <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => {
                                      setSelectedApp(cell);
                                      editar(cell);
                                    }}
                                  >
                                    <div className="aling-icon">
                                      {" "}
                                      <img
                                        src={editar_icon}
                                        alt="editar"
                                        className="px-1"
                                      ></img>{" "}
                                      Editar
                                    </div>
                                  </button>
                                  <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => handleArchivar(cell)}
                                  >
                                    <div className="aling-icon-archivar">
                                      {" "}
                                      <img
                                        src={archivar_blanco}
                                        alt="archivar"
                                        className="px-2"
                                      ></img>{" "}
                                      Archivar
                                    </div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        );
                      }
                    }
                    return (
                      <td
                        className="contenido_boolean"
                        {...cell.getCellProps()}
                        onClick={() => {
                          setSelectedApp(cell);
                          editar(cell);
                        }}
                      >
                        {cell.render("Cell")}{" "}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
      )}

      {buildPopUp()}
      {buildPopUpApp()}
    </>
  );
}

function Tabla(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "idApp",
      },
      {
        Header: "Nombre",
        accessor: "nombre",
      },
      {
        Header: "URL",
        accessor: "url",
      },
      {
        Header: "Path",
        accessor: "path",
      },
      {
        Header: "Activo",
        accessor: "activo",
      },
      {
        Header: "Protegida",
        accessor: "protegida",
      },
      {
        Header: "Soporte",
        accessor: "pathSoporte",
      },
    ],
    []
  );
  return (
    <>
      <Table
        columns={columns}
        data={props.aplicaciones}
        servicio={props.servicio}
        marca={props.marca}
        nombreMarca={props.marcaNombre}
        tiposAutenticacion={props.tiposAutenticacion}
        handleChange={props.handleChange}
      />
    </>
  );
}

export default Tabla;
